import { z } from "zod"

export const JobAlertSchema = z.object({
   email: z.string().min(1, "Email is required").email("Invalid email address"),
   email_frequency: z.enum(["Daily", "Weekly", "Monthly"], {
      errorMap: () => ({ message: "Please select a valid frequency" }),
   }),
})

export type JobAlertFormData = z.infer<typeof JobAlertSchema>